import React from "react"

import { MediaOption } from "shared/ui/media-option/MediaOption"

import { ProjectImage } from "entities/projects/ui/project-image/ProjectImage"
import { ProjectPhaseChip } from "entities/projects/ui/project-phase-chip/ProjectPhaseChip"
import { ProjectRoleChip } from "entities/projects/ui/project-role-chip/ProjectRoleChip"
import { ProjectTitle } from "entities/projects/ui/project-title/ProjectTitle"

import { ProjectOption } from "../../../../types/GlobalSearch"
import { GlobalSearchListItem } from "./GlobalSearchListItem"

interface ProjectGlobalSearchListItemProps {
  option: ProjectOption
  index: number
  isTabActive: boolean
}

export const ProjectGlobalSearchListItem = React.memo(
  ({ option, index, isTabActive }: ProjectGlobalSearchListItemProps) => {
    const { project, role, matchInfo } = option.data
    return (
      <GlobalSearchListItem
        index={index}
        option={option}
        isTabActive={isTabActive}
        className="global-search__list-item--project"
      >
        <MediaOption.Root variant="product">
          <MediaOption.Media aria-hidden>
            <ProjectImage color={project?.ui?.color} />
          </MediaOption.Media>
          <MediaOption.Label>
            <ProjectTitle project={project} ranges={matchInfo.title?.ranges} />
          </MediaOption.Label>
          <MediaOption.Subtext>
            <ProjectPhaseChip phase={project.phase} />
            {project.team?.id ? <ProjectRoleChip teamRole={role} /> : null}
          </MediaOption.Subtext>
        </MediaOption.Root>
      </GlobalSearchListItem>
    )
  }
)
